import classnames from 'classnames';
import compact from 'lodash/compact';
import flatMap from 'lodash/flatMap';
import map from 'lodash/map';
import { arrayOf, bool, func, object, string } from 'prop-types';
import React from 'react';
import Select from 'react-select';
import { Button } from 'reactstrap';

import { optionShape } from '../../prop-types';
import getDatasetFromProps from '../../utils/get-dataset-from-props';

function pickOptions(values = [], options = []) {
  const flatOptions = flatMap(options, option =>
    option.value ? option : option.options,
  );
  const extractedValues = values.map(
    v => flatOptions.find(option => option.value === v) || '',
  );
  return compact(extractedValues);
}

class MultiSelect extends React.Component {
  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(selectedOption) {
    const { name, onChange } = this.props;
    const syntheticSyntheticEvent = {
      target: {
        value: map(selectedOption, 'value').sort(),
        name,
        type: 'multiselect',
        dataset: getDatasetFromProps(this.props),
      },
    };
    onChange(syntheticSyntheticEvent);
  }

  render() {
    const {
      value,
      options,
      readOnly,
      className,
      id,
      placeholder,
      onChange,
      addAllOption,
      selectAllLabel,
      inlineAddAll,
      components,
      ...rest
    } = this.props;
    return (
      <div className={classnames('w-100', { 'd-flex': inlineAddAll })}>
        <Select
          isMulti
          placeholder={placeholder || (readOnly ? '' : 'Select…')}
          classNamePrefix="m-select"
          className={classnames('m-select', className)}
          value={pickOptions(value, options)}
          onChange={this.handleChange}
          inputId={id}
          options={options}
          {...rest}
          isDisabled={readOnly}
          components={components}
        />
        {addAllOption && (
          <Button
            className={classnames(
              'btn btn-sm btn-outline-secondary text-nowrap',
              {
                'mt-2': !inlineAddAll,
              },
            )}
            color="light"
            onClick={() => this.handleChange(options)}
          >
            {selectAllLabel}
          </Button>
        )}
      </div>
    );
  }
}

MultiSelect.propTypes = {
  value: arrayOf(string.isRequired).isRequired,
  options: arrayOf(optionShape).isRequired,
  readOnly: bool,
  placeholder: string,
  name: string,
  onChange: func,
  className: string,
  id: string,
  isClearable: bool,
  addAllOption: bool,
  inlineAddAll: bool,
  selectAllLabel: string,
  components: object, // eslint-disable-line react/forbid-prop-types
};

MultiSelect.defaultProps = {
  readOnly: false,
  placeholder: '',
  name: '',
  onChange: () => {},
  className: null,
  id: undefined,
  isClearable: false,
  addAllOption: false,
  inlineAddAll: false,
  selectAllLabel: 'Select All',
  components: undefined,
};

export default MultiSelect;
